import { Dialog } from '#/components/Dialog'
import { ConfirmDialog } from '#/store/hooks/useConfirmDialog/ConfirmDialog'
import { AllForms, BuildFormProps } from '#/store/hooks/useFormBuilder/types'
import { useForms } from '#/store/hooks/useForms'
import { Sentry } from '#/store/services/Sentry'
import { listeners } from '#/utils/listeners'

export const useConfirmDialog = () => {
  const forms = useForms()

  const confirm = <TFormName extends keyof AllForms, TFormType extends keyof AllForms[TFormName]>({
    afterSuccess,
    formName,
    formType,
    params,
  }: BuildFormProps<TFormName, TFormType>) => {
    const formFunction = forms?.[formName]?.[formType]
    const form = (formFunction as any)({ params })

    const handleClose = () => {
      Dialog.close()
    }

    Sentry.hitForm({ formName, formType } as any)

    Dialog.open({
      content: (
        <ConfirmDialog
          {...form}
          onClose={handleClose}
          afterSuccess={() => {
            afterSuccess?.()
            window.dispatchEvent(new Event(listeners.animal))
            window.dispatchEvent(new Event(listeners.datagrid))
            window.dispatchEvent(new Event(listeners.listbuilder))
          }}
        />
      ),
    })
  }

  return { confirm }
}
